import Contact from "./Contact";
import ToolTech from "./ToolTech";
import Education from "./Education";

import styles from "./About.module.css";
import Intro from "./Intro";
import { useEffect, useState } from "react";

const About = (props) => {
  const [scrollOffset, setScrollOffset] = useState(0);

  useEffect(() => {
    const scrollHandler = (event) => {
      setScrollOffset(document.documentElement.scrollTop);
    };

    window.addEventListener("scroll", scrollHandler);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <section className={styles["about-page"]}>
      <p className={styles["bg-text"]}>ABOUT MEEE!</p>
      <Intro />
      <Education scrollOffset={scrollOffset} />
      <ToolTech scrollOffset={scrollOffset} />
      <Contact scrollOffset={scrollOffset} />
    </section>
  );
};

export default About;
